import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Cert1 from "../../images/cert1.png";
import Cert2 from "../../images/cert2.png";
import Cert3 from "../../images/cert3.png";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import "./Slider.css";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';;

export default function App() {
  const [swiperRef, setSwiperRef] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const certtificateImages = [Cert1, Cert2, Cert3, Cert1];
  const [activeIndex, setActiveIndex] = useState(0);

  const openModal = (imageSrc) => {
    setCurrentImage(imageSrc);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage("");
  };

  return (
    <div className="swiper-block">
      <div className="swiper-box">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        
          // navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {certtificateImages.map((image, index) => (
            <SwiperSlide className="slide-block"><img className="cert-img" src={image} onClick={() => openModal(image)} alt="Certificate img" /></SwiperSlide>
          ))}
          
        </Swiper>
      </div>

      {isModalOpen && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              className="modal-image"
              src={currentImage}
              alt="Full-size certificate"
            />
          </div>
        </div>
      )}
    </div>
  );
}
